import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'bfa-message-dialog',
	templateUrl: './message-dialog.component.html',
	styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent {

	constructor(
		public dialogRef: MatDialogRef<MessageDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		if (!this.data && !this.data.message) {
			console.error('You need to supply an error message. Defaulting to empty string!');
		}
	}

	public directToPage(action: any): void {
		this.dialogRef.close();

		if (action.url) {
			window.location.assign(action.url);
		} else if (action.reload) {
			window.location.reload();
		} else {
			console.error('Missing url or params for redirect action!');
		}
	}

	public getTrackMsg(actionLabel: string): string {
		return this.data.message.trackMsgPrefix ? this.data.message.trackMsgPrefix + actionLabel : actionLabel;
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}
}
